import { DealerBranding } from "@app/entity/model/dealer-branding";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { DealerBrandingState, initialDealerBrandingState } from "../dealer-branding.state";

const selectState = createFeatureSelector<DealerBrandingState>("dealerBranding");

export const getDealerBrandingCallState = createSelector(
    selectState,
    (state: DealerBrandingState = initialDealerBrandingState) => state.dealerBrandingImages.callState
);
export const selectDealerBrandingState = createSelector(
    selectState,
    (state: DealerBrandingState = initialDealerBrandingState) => state.dealerBrandingImages
);

export const selectDealerBrandingImagesListState = createSelector(
    selectState,
    (state: DealerBrandingState = initialDealerBrandingState) => state.dealerBrandingImageList
);

export const selectDealerBrandingImages = createSelector(
    selectState,
    (dealerBrandingState: DealerBrandingState = initialDealerBrandingState) => dealerBrandingState.dealerBrandingImages.result
);
/**
 * Uses Key to return selected DealerBranding image
 *
 * @param {string} key identifies selected DealerBranding image
 * @returns {DealerBranding} DealerBranding image object used for download and display
 */
export const selectDealerBrandingImageByKey = (key: string) =>
    createSelector(selectDealerBrandingImages, (images: { [key: string]: DealerBranding }) => (images ? images[key] : null));
